module.exports = __webpack_public_path__ + "media/images/navbar/apropos-043e1d0c3ac66c125d7c3166ac70c078.png";